import { getUserDetailsByIp } from './clients/user';

// This file is deprecated

export { getUserDetailsByIp };
